var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"smart-button-container"}},[_c('div',[_c('div',{attrs:{"id":"paypal-button-container"}},[_c('paypal-buttons',{attrs:{"onApprove":_vm.onApprove,"createOrder":_vm.createOrder,"onError":_vm.onError}})],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }